// import { createApp } from 'vue'
import AlertModal from '@/components/Common/AlertModal.vue'

const Alert = {}

Alert.install = function(Vue) {

    const AlertConstructor = Vue.extend(AlertModal);
    const instance = new AlertConstructor();
    instance.$mount(document.createElement("div"));

    Vue.prototype.$alert = (params) => {
        document.body.appendChild(instance.$el);
        instance.show(params)
    };
}


export default Alert;